module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA+0lEQVQ4y52TS2qEQBCGqyVX8RBzBVch0D6yyCKSLDKzmEUIIYtcIgkI4glUxAeNCIIIop7BkwyDdlYF7SJY8V/Wz9f16gIgqqqqZ8/z/HmeNTV+Q4HLsnzxff8LABB+Qk/bgoUQpyAIfgBAY4wtuq731KqhKIoz51xyzqVpmnPTNA9kOMuyV4Qty7q2bXtPhpMkeVPhrutMMhzH8QfCtm1f+r6/I8NhGH4i7DjOZRzH2y1mtQUp5cpkjC3k7KgoilYtDMNAb0EZ4vvuIaLSNN2/RlSe5/s/EkoIcVIfqev6UfU3b8EwjG/XdY8AsEgptWmaDv+uAuDvc/4F0uSZthiwjpAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back-arrow.png
// module id = 1F8j
// module chunks = 1